import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    bpiStatusColumnKey,
    bonusReportKey,
    initiatedColumnKey,
    lastCloseColumnKey,
    marketRelativeStrengthColumnKey,
    modelPortfolioKey,
    mttProductKey,
    mttVimeoKey,
    openedPositionKey,
    openPositionsTitle,
    peerRelativeStrengthColumnKey,
    positionSizeCalculatorKey,
    sectorColumnKey,
    sectorRelativeStrengthColumnKey,
    sectorTreeKey,
    stanceColumnKey,
    symbolColumnKey,
    tradeAlertKey,
    webinarKey,
    openedStockPriceColumnKey,
    stopLossColumnKey,
    priceTargetColumnKey,
    closedPositionKey,
    closedPositionsTitle,
    closedColumnKey,
    closedStockPriceColumnKey,
    stockGainsColumnKey,
    monthEndGainColumnKey,
    maxGainColumnKey,
    initiatedKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: mttProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                stanceColumnKey,
                sectorColumnKey,
                lastCloseColumnKey,
                bpiStatusColumnKey,
                sectorRelativeStrengthColumnKey,
                peerRelativeStrengthColumnKey,
                marketRelativeStrengthColumnKey,
                initiatedColumnKey,
                openedStockPriceColumnKey,
                priceTargetColumnKey,
                stopLossColumnKey,
                actionsColumnKey
            ]
        },
        {
            key: closedPositionKey,
            title: closedPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                sectorColumnKey,
                initiatedColumnKey,
                closedColumnKey,
                openedStockPriceColumnKey,
                closedStockPriceColumnKey,
                stockGainsColumnKey,
                monthEndGainColumnKey,
                maxGainColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    mttVimeoKey,
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    webinarKey,
    positionSizeCalculatorKey,
    sectorTreeKey
];

export function useMonthlyTrendTrader() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( mttProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'MTT', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
